<div class="date-picker-container" [class.mobile-padding]="isPlugin">
    <div class="container__mobile-hidden">
        <wizard-labeled-field [label]="schedulingWindowLabel" class="margin-bottom-10">
            <wizard-tooltip>
                <ng-container *ngIf="selectedPicker === 'range'; else showSpecificTimeTooltip">
                    Select your required date and time range for the meeting and CalendarHero will automatically find
                    the best time that works for all attendees.
                    <a href="https://faq.calendarhero.com/hc/en-us/articles/4430389182235-How-do-I-customize-my-Availability-Window-" target="_blank"
                        >Learn More</a
                    >
                </ng-container>
                <ng-template #showSpecificTimeTooltip>
                    Use this option if you already know the date and time you want the meeting scheduled to. All
                    attendees will be notified and calendars will automatically be updated.
                    <a
                        href="https://faq.calendarhero.com/hc/en-us/articles/4430391480091-How-do-I-customize-the-date-range-for-time-sensitive-meetings-"
                        target="_blank"
                        >Learn More</a
                    >
                </ng-template>
            </wizard-tooltip>
        </wizard-labeled-field>
    </div>
    <div *ngIf="showSchedulingOptions" class="schedule__options">
        <div class="ui radio checkbox">
            <input
                type="radio"
                name="reschedule"
                [checked]="selectedPicker === 'range'"
                (click)="handleSelect('range')"
            />
            <label>Ask my invitees to select a time</label>
        </div>
        <div class="ui radio checkbox">
            <input
                type="radio"
                name="reschedule"
                [checked]="selectedPicker === 'specific'"
                (click)="handleSelect('specific')"
            />
            <label>Schedule at a specific time</label>
        </div>
    </div>
    <ng-container *ngIf="selectedPicker === 'range'; else showSpecificDatePicker">
        <ng-container *ngIf="isPlugin; else showDefault">
            <div class="date-picker__date-range">
                <wizard-date-range
                    [classes]="datepickerClasses"
                    fieldSize="auto"
                    (onUpdateDateRangeMode)="handleUpdateDateRangeMode($event)"
                ></wizard-date-range>
            </div>
        </ng-container>
        <ng-template #showDefault>
            <div class="date-picker-row">
                <div class="date-picker__actions">
                    <div class="date-picker__date-range">
                        <wizard-date-range
                            [classes]="datepickerClasses"
                            fieldSize="auto"
                            (onUpdateDateRangeMode)="handleUpdateDateRangeMode($event)"
                        ></wizard-date-range>
                    </div>
                    <div class="date-picker__quick-dates" *ngIf="dateRangeMode === 'fixed-dates'">
                        <wizard-quick-dates></wizard-quick-dates>
                    </div>
                </div>
                <div class="fc-toggle-container">
                    <div class="ui toggle checkbox">
                        <input type="checkbox" [(ngModel)]="showCalendar" />
                        <label [class.disabled]="!showCalendar">View Availability Window</label>
                    </div>
                </div>
            </div>
            <div class="date-picker-calendar" [class.hidden]="!showCalendar">
                <wizard-time-picker [classes]="datepickerClasses" fieldSize="tiny"></wizard-time-picker>
            </div>
        </ng-template>
    </ng-container>
    <ng-template #showSpecificDatePicker><wizard-specific-date-picker></wizard-specific-date-picker></ng-template>
</div>
